export default {
  第: '第',
  年: '年',
  届: '届',
  开幕中: '开幕中',
  全部展览: '全部展览',
  热门推荐: '热门推荐',
  当前展次: '当前展次',
  参观数量: '参观数量',
  国内: '国内',
  国外: '国外',
  国际: '国际',
  开幕日期: '开幕日期',
  正在参展: '正在参展',
  展览简介: '展览简介',
  供应链简介: '供应链简介',
  展览范围: '展览范围',
  产业覆盖: '产业覆盖',
  照片直播: '照片直播',
  展览费用: '展览费用',
  展馆信息: '展馆信息',
  组织机构: '组织机构',
  国内企业: '国内企业',
  境外企业: '境外企业',
  物品清单: '物品清单',
  注意事项: '注意事项',
  免责声明: '免责声明',
  场馆面积: '场馆面积',
  国家地区: '国家地区',
  展览面积: '展览面积',
  展馆地址: '展馆地址',
  主办单位: '主办单位',
  支持单位: '支持单位',
  协办单位: '协办单位',
  承办单位: '承办单位',
  标准展位: '标准展位',
  豪华标准展位: '豪华标准展位',
  空地: '空地',
  参展提示: '参展提示',
  去申请认证: '去申请认证',
  参展商报名: '参展商报名',
  参观商报名: '参观商报名',
  展台搭建: '展台搭建',
  开展时间: '开展时间',
  展览地点: '展览地点',
  该展览已下架: '该展览已下架',
  该展览不存在: '该展览不存在',
  '您是参观商,不能申请展厅搭建': '您是参观商,不能申请展厅搭建',
  '您是服务商,不能申请展厅搭建': '您是服务商,不能申请展厅搭建',
  报名成功: '报名成功',
  参观商参展提示: '您当前会员身份为参观商,需要先申请认证成为参展商,平台审核通过即可参展报名！',
  主办商参展提示: '您是主办商,不能参展报名,您可以参观报名',
  服务商参展提示: '您是服务商,不能参展报名,您可以参观报名',
  暂无相关的云上展览: '暂无相关的云上展览',
  '参展商数量（预计参展数）': '参展商数量（预计参展数）',
  请填写数字: '请填写数字',
  '参观商数量（预计参观数）': '参观商数量（预计参观数）',
  请输入组织机构: '请输入组织机构',
  请输入展馆信息: '请输入展馆信息',
  展品范围: '展品范围',
  请输入展品范围: '请输入展品范围',
  选择头条内容: '选择头条内容',
  参展数量: '参展数量',
  相关资讯: '相关资讯',
  相关展览: '相关展览',
  距离展览开幕还有: '距离展览开幕还有',
}
